import { ObservableArray, View } from "binder"
import { IExecutablePart } from "../executablePart/executablePart";
import { ExecutableViewModel } from "./executable-viewModel"

export class ExecutableView extends View<ExecutableViewModel>{
    GetViewUniqueId(): string {
        return "V-93C561D6-3D21-4BB7-A99F-C09D7B2998FE"
    }
    loadHtml(): string {
        let element = require('./executable.html').default;
        let style = require('./executable.less');
        return element;
    }
    constructor() {
       super();
    }

    public set executableParts(v: ObservableArray<IExecutablePart>) { this._executableParts = v; } public get executableParts(): ObservableArray<IExecutablePart> { return this._executableParts;} private _executableParts: ObservableArray<IExecutablePart>;

}
